import { Injectable } from '@angular/core';
import { AirTicketResourceService } from "libraries/service/resources/air-ticket-resource/air-ticket-resource.service";
import { Observable, of } from "rxjs";
import {
    RequestForTicketingReportSearch,
    ResponseForConvertTicketsAfx2jsonType,
    TicketAirType,
    TicketingReportSearchTicket
} from "@afidium/ts-facade";
import { ICodeName } from "libraries/service/resources/model/shared/ICodeName";
import { EnumsResourceService } from "libraries/service/booking/enums/enums-resource.service";
import { map, tap } from "rxjs/operators";
import * as moment from "moment";
import { ExportFormats, IApiExportResponse } from "libraries/interfaces/IApiExportResponse";
import { SortDirection } from "libraries/interfaces/ISort";

export interface IApiSorting {
    fieldKey: SortKey;
    order: SortDirection;
}

export enum SortKey {
    eventDate = 'EVENT_DATE',
    ticketNumber = 'TICKET_NUMBER',
    system = 'SYSTEM',
    type = 'TYPE',
    purpose = 'PURPOSE',
}

@Injectable()
export class TicketingReportDomainService {

    private readonly dummyExport: IApiExportResponse = {
        name: "journal_d_emission.xlsx",
        format: ExportFormats.XLSX,
        url: 'https://nightly.afidium.com/sasha/data/afi_bkg/exports/Export_de_dossiers_2021-10-18_d5e696db.xlsx',
    };

    constructor(
        private readonly airTicketResourceService: AirTicketResourceService,
        private readonly enumsResourceService: EnumsResourceService,
    ) {
    }

    public search(request: RequestForTicketingReportSearch): Observable<ResponseForConvertTicketsAfx2jsonType> {
        return this.airTicketResourceService.searchTickets(request);
    }

    public getCustomFields(): Observable<ICodeName[]> {
        return this.enumsResourceService.listTicketingReportBookingCustomFields();
    }

    public export(request: RequestForTicketingReportSearch): Observable<IApiExportResponse> {
        // return of(this.dummyExport);
        return this.airTicketResourceService.export(request, ExportFormats.XLSX);
    }

}
